import React from 'react';

import { Box } from '@mui/material';

import DemoButton from './RibbonComponents/DemoButton';
import SubscriptionPlanChip from './RibbonComponents/SubscriptionPlanChip';
import HelpMenu from './RibbonComponents/HelpMenu';
import UserMenu from './RibbonComponents/UserMenu';
import SearchButton from './RibbonComponents/SearchButton';
import CurrencyChangeMenu from '../../CurrencyChangeMenu';
import { getIfDemoMarketOptionVisible } from '../helper';

const Ribbon = ({
  isMobile,
  setIsMobileSearchBarOpen,
  logoutThunk,
  setCurrency,
  user,
  currency,
  setLoginModalOpen,
  dashboardState,
  handleMarketSidebarClick,
  setSubscriptionModalOpen,
  handleSidebarListItemClick,
  centerCoord,
  address,
  openDemoBookingForm,
  setDemoFormHeadingFor,
  dummyMarket,
  isMarketDashboard,
}) => {
  const isDemoMarketOptionVisible = getIfDemoMarketOptionVisible(window.location.pathname, dummyMarket);

  const getSubscriptionPlanChip = (isRenderedInOption: boolean = false) => {
    return (
      <SubscriptionPlanChip
        dashboardState={dashboardState}
        setSubscriptionModalOpen={setSubscriptionModalOpen}
        address={address}
        centerCoord={centerCoord}
        setLoginModalOpen={setLoginModalOpen}
        isRenderedInOption={isRenderedInOption}
      />
    );
  };

  const getDemoMarketButton = (isRenderedInOption: boolean = false) => {
    return <DemoButton dummyMarket={dummyMarket} isRenderedInOption={isRenderedInOption} />;
  };

  return (
    <Box sx={{ display: 'flex', gap: isMobile? 0.5 : 2, alignItems: 'center' }}>
      {!isMobile && getSubscriptionPlanChip()}
      {!isMobile && isDemoMarketOptionVisible && user.subscriptionPlan === 'starter' && getDemoMarketButton()}
      {/* {isMobile && isMarketDashboard && (
        <SearchButton setIsMobileSearchBarOpen={setIsMobileSearchBarOpen} />
      )} */}
      {!isMobile && (
        <CurrencyChangeMenu
          currency={currency}
          setCurrency={setCurrency}
          fullWidth={false}
          renderAsText={true}
        />
      )}
      <HelpMenu
        handleMarketSidebarClick={handleMarketSidebarClick}
        handleSidebarListItemClick={handleSidebarListItemClick}
        openDemoBookingForm={openDemoBookingForm}
        setDemoFormHeadingFor={setDemoFormHeadingFor}
      />
      <UserMenu
        logoutThunk={logoutThunk}
        user={user}
        handleMarketSidebarClick={handleMarketSidebarClick}
        currency={currency}
        setCurrency={setCurrency}
        setLoginModalOpen={setLoginModalOpen}
        centerCoord={centerCoord}
        address={address}
        isMobile={isMobile}
        dummyMarket={dummyMarket}
        setSubscriptionModalOpen={setSubscriptionModalOpen}
        dashboardState={dashboardState}
      />
    </Box>
  );
};

export default Ribbon;
